import AiDiamonds from "@/components/AiDiamonds";
import { sampleSurveys } from "@/tmp/sample-surveys";
import { Link } from "react-router-dom";

export const TemplateSurveys = () => {
  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
        {sampleSurveys.map((survey) => (
          <Link
            to="/newsurvey"
            state={{ templateSurvey: survey }}
            key={survey.id}
          >
            <div className="px-4 py-4 border border-gray-500 mb-4 bg-slate-800 hover:bg-slate-700 shadow hover:shadow-sky-600 h-full">
              <div className="text-xs text-slate-400 mb-2">TEMPLATE</div>
              <h3 className="font-semibold mb-4">
                <AiDiamonds />
                {survey.header?.title}
              </h3>
              <p className="text-sm">{survey.header?.contextAndObjectives}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
